export default {
  props: {
    conversation: {
      type: Object,
      required: true
    }
  },
  computed: {
    user () {
      return [
        this.conversation.from,
        this.conversation.to
      ]
        .filter(e => e.scope === 'user')[0]
    },
    expert () {
      return [
        this.conversation.from,
        this.conversation.to
      ]
        .filter(e => e.scope === 'admin')[0]
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/withConversation.js